import {getUsers, updateUser, addUser, uploadNewUsers, delUser, uploadNewOperatorUsers} from '../helpers/userService';
import { checkError, receiveErrorAlert, closeAlert } from './commonsActions';

/*
 * action types
 */

export const FETCH_USERS_BEGIN   = 'FETCH_USERS_BEGIN';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const GET_FILTERED_USER = 'GET_FILTERED_USER';

/*
 * action creators
 */

export const fetchUsersBegin = () => ({
	type: FETCH_USERS_BEGIN
});

export const fetchUsersSuccess = users => ({
	type: FETCH_USERS_SUCCESS,
	payload: {
		users: users.data,
		numberOfElements : users.numberOfElements,
		totalElements: users.totalElements,
		totalPages: users.totalPages
	}
});

export const filteringUsers = filter => (dispatch, getState) => {
	const state = getState();
	let filteredUsers = state.users.users;
	if (filter) {
		filter.forEach(item => {
			filteredUsers = filteredUsers.filter( user => {
				if (item.value && item.value !== '') {
					if (user[item.name] == null) {
						return false
					}
					return user[item.name].toLowerCase().indexOf(item.value.toLowerCase()) !== -1
				} else {
					return true;
				}
			});
		})
	} else {
		filteredUsers = state.users.users;
	}
	dispatch({
		type: GET_FILTERED_USER,
		users: filteredUsers
	});
};

export const fetchUsers = query => dispatch => {
	dispatch(fetchUsersBegin());
	return getUsers(query).then(res => {
		dispatch(fetchUsersSuccess(res));
		return res
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const saveNewUser = newUser => dispatch => {
	return addUser({
		name: newUser.name,
		email: newUser.email,
		phoneNumber: newUser.phoneNumber,
		login: newUser.email,
		role: newUser.role,
		status: newUser.status,
		password: newUser.password,
		repeatPassword: newUser.repeatPassword,
		companyId: +newUser.companyId,
		defaultPassword: newUser.defaultPassword,
		visibleSalesPointIds: newUser.visibleSalesPointIds,

	}).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})

};

export const updateSingleUser = user => {
	return dispatch => {
		console.log(user);
		const currentUser = {
            id: user.id,
            name: user.name,
            // email: user.email,
			phoneNumber: user.phoneNumber,
            role: user.role,
            status: user.status,
            companyId: +user.companyId,
            defaultPassword: user.defaultPassword,
			visibleSalesPointIds: user.visibleSalesPointIds,
        };
		if (user.defaultPassword === true) {
            currentUser.password = user.password;
			currentUser.repeatPassword = user.repeatPassword;
		};
		return updateUser(currentUser).then(res => {
			return res;
		}, error => {
			dispatch(checkError(error));
			dispatch(receiveErrorAlert(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 2000);
		})
	};
};

export const uploadUserFile = (file) => dispatch =>{
	return uploadNewUsers(file).then(res => {
		console.log('res___', res);
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const uploadOperatorUserFile = (file) => dispatch =>{
	return uploadNewOperatorUsers(file).then(res => {
		console.log('res___', res);
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const deleteUser = userId => dispatch =>{
	return delUser(userId).then(res => {
		console.log('res___', res);
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};




// WEBPACK FOOTER //
// ./src/actions/usersActions.js